
import { FC } from 'react';

export interface IOption {
  label: string;
  key: any;
}

export interface IRadioProps {
  onChange: (value: boolean) => void;
  name: string;
  value?: any;
  error?: string;
  readOnly?: boolean;
  options: IOption[];
}

export const Radio: FC<IRadioProps> = ({ onChange, options, value, error, name, readOnly }) => {
  return <div className='cb-radio-custom'>{options.map((option) => {
    return <label key={`${name}-${option.key}-radio`}>
      <input disabled={readOnly} className='cb-radio-style' type='radio' checked={value === option.key ? true : false} onChange={() => { onChange(option.key); }}></input> {option.label}
    </label>;
  })}
    {error &&
      <span style={{ marginTop: '2px', marginBottom: '8px' }} className='cb-input-helper cb-validation-error'>{error}</span>
    }
  </div>;
};